import React from 'react';
import {Content, Container, EventInformation, Minute, DataContainer} from 'app/components/matchEvents/MatchEventStyles';
import {Line, Typography} from '@fupa/fupa-uikit';
import {SubstitutionInOut} from 'app/components/icons';

const MatchEventSubstitution = ({event}) => {
  let subIn =
    event.primaryRole && event.primaryRole.player
      ? `${event.primaryRole.player.firstName} ${event.primaryRole.player.lastName}`
      : 'Unbekannter Spieler';
  let subOut =
    event.secondaryRole && event.secondaryRole.player
      ? `${event.secondaryRole.player.firstName} ${event.secondaryRole.player.lastName}`
      : 'unbekannten Spieler';
  const substitution = `${subIn} für ${subOut}`;
  const standingMessage = `Wechsel bei ${event.team?.name?.middle ?? 'nicht angegebenem Team'}`;
  const time = event.additionalMinute > 0 ? `${event.minute}'+${event.additionalMinute}` : `${event.minute}'`;

  return (
    <Content>
      <Container>
        <EventInformation>
          <Minute variant='subheading2' component='span'>
            {time}
          </Minute>
          <SubstitutionInOut style={{fontSize: 16}} />
        </EventInformation>
        <DataContainer>
          <Typography variant='body1'>{standingMessage}</Typography>
          <Typography variant='body2'>{substitution}</Typography>
        </DataContainer>
      </Container>
      <Line />
    </Content>
  );
};

export default MatchEventSubstitution;
